/* eslint-disable comma-dangle */
/* eslint-disable react/no-danger */
/* eslint-disable react/no-unused-prop-types */
/* eslint-disable react/require-default-props */

import { Bell, Customer, Logout, MenuIcon } from '@cashew/assets';
import { api } from '@cashew/utils';
import cn from 'classnames';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useHistory } from 'react-router-dom';
import SelectStore from './SelectStore';
import './index.scss';

const ns = 'header';

type HeaderType = {
  updateAuth: (flag: boolean) => void;
  type: string;
  setShowMenu: (flag: boolean) => void;
  postLogoutAction: any;
  windowDimensions: any;
  showStores: boolean;
  showAllOption?: boolean;
};

export default ({
  updateAuth,
  type,
  setShowMenu,
  postLogoutAction,
  showStores = true,
  showAllOption = true,
}: HeaderType) => {
  const { token, language } = useSelector((state: any) => state.user);
  const history = useHistory();
  const dispatch = useDispatch();
  const [hasUnreadNotifications, setHasUnreadNotifications] = useState(false);
  useEffect(() => {
    api
      .get({
        endpoint: 'notifications',
        headers: {
          Authorization: token,
        },
      })
      .then((resp) => {
        setHasUnreadNotifications(resp.data.unreadCount > 0);
      })
      .catch((resp) =>
        api.errorHandler({
          resp,
          history,
          dispatch,
        })
      );
  }, []);

  return (
    <header className={ns}>
      <button className={`${ns}__menu`} onClick={() => setShowMenu(true)}>
        <MenuIcon />
      </button>
      <div className={`${ns}__container`}>
        {type === 'merchant' && showStores && (
          <div className={`${ns}__stores`}>
            <SelectStore showAllOption={showAllOption} />
          </div>
        )}
        {type !== 'cashew' && (
          <Link
            to={`/${language}/notifications`}
            className={cn(`${ns}__notifications`, {
              [`${ns}__notifications--unread`]: hasUnreadNotifications,
            })}
          >
            <Bell />
          </Link>
        )}
        {type === 'customer' && (
          <Link to={`/${language}/profile`} className={`${ns}__settings`}>
            <Customer />
          </Link>
        )}
        <button
          className={`${ns}__logout`}
          onClick={() => {
            api
              .get({
                endpoint: `identity/${type}/logout`,
                headers: {
                  Authorization: token,
                },
              })
              .then(() => {
                dispatch(updateAuth(false));
                history.push('/');
                if (postLogoutAction) {
                  postLogoutAction();
                }
              })
              .catch();
          }}
        >
          <Logout />
        </button>
      </div>
    </header>
  );
};
